import React, { useMemo, useState } from 'react';

import { Slider } from '@atlas/components';
import { CasinoGameTopTile, ChipsItem, Icon, Label } from '@atlas/ui';

import { CDN_TYPE_CMS, imageUrlCDN } from 'src/common/utils';

const LobbyGameTopCategoriesBlock = ({ blockTitleKey, blocks, imageUrl }) => {
  const [swiper, setSwiper] = useState(null);
  const prevSlide = () => swiper && swiper.slidePrev();
  const nextSlide = () => swiper && swiper.slideNext();
  const [isShowImg, toggleVisibilityImg] = useState(!!imageUrl);
  const handleError = () => toggleVisibilityImg(false);

  const finalItems = blocks || [];

  const responsiveSliderSettings = useMemo(() => {
    return {
      1: {
        slidesPerView: 2,
      },
      1000: {
        slidesPerView: 4,
      },
      1250: {
        slidesPerView: 5,
      },
      1550: {
        slidesPerView: 6,
      },
      730: {
        slidesPerView: 3,
      },
    };
  }, []);

  if (!finalItems || finalItems.length === 0) {
    return null;
  }

  return (
    <div className="casino-lobby__item lobby-game-top">
      <div className="casino-lobby__header">
        <div className="casino-lobby__left">
          {isShowImg && (
            <div className="casino-lobby__icon">
              <img
                alt={blockTitleKey}
                height={32}
                onError={handleError}
                role="presentation"
                src={`${encodeURI(imageUrlCDN(imageUrl, CDN_TYPE_CMS))}`}
                width={32}
              />
            </div>
          )}

          {blockTitleKey && (
            <div className="casino-lobby__title">
              <Label message={blockTitleKey} />
            </div>
          )}
        </div>
        <div className="casino-lobby__right">
          <ChipsItem
            className="casino-lobby__arrow casino-lobby__arrow-left"
            label={<Icon name="arrow-left" />}
            onClick={prevSlide}
          />
          <ChipsItem
            className="casino-lobby__arrow casino-lobby__arrow-right"
            label={<Icon name="arrow-right" />}
            onClick={nextSlide}
          />
        </div>
      </div>
      <div className="casino-lobby__content">
        <div className="lobby-game-top__slider">
          <Slider
            autoplay={false}
            breakpoints={responsiveSliderSettings}
            breakpointsBase="container"
            direction="horizontal"
            onBeforeInit={setSwiper}
            slidesPerView={4}
            spaceBetween={14}
          >
            {finalItems.map((item, index) => (
              <Slider.Slide
                autoplay={false}
                breakpointsBase="container"
                key={`${crypto.randomUUID()}`}
              >
                <CasinoGameTopTile
                  game={{
                    iconUrl:
                      'https://d1fojj4wte942r.cloudfront.net/e-games/luckypunch_onlyplay_direct_desktop_mobile_icon_1677234644490.webp',
                    id: index,
                    name: 'Lucky Punch',
                    provider: 'Onlyplay',
                  }}
                  index={index}
                  isLoading={false}
                  isMobile={false}
                />
              </Slider.Slide>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default LobbyGameTopCategoriesBlock;
